import allCategories from './allCategories'
import allProducts from './allProducts'

const initialState = {
  produtosTodos: [],
  produtos: [],
  total: 0,
  loading: true,
  categorias: allCategories.map((cat) => {
    return { ...cat, selecionado: false }
  }),
}

export default function products(state = initialState, action) {
  switch (action.type) {
    case 'START_FETCH_PRODUCTS':
      return { ...state, loading: true }

    case 'END_FETCH_PRODUCTS':
      return { ...state, loading: false }

    case 'SEARCH_COUNT_PRODUCT':
      return { ...state, total: action.total }

    case 'SEARCH_PRODUCT':
      if (action.alvo.trim() == '') {
        return state
      }

      const returnPesquisaCodigo = state.produtosTodos.filter(
        (p) => p.codipro == action.alvo.trim()
      )
      const returnPesquisaDescricao = state.produtosTodos.filter((p) =>
        p.descricao.toLowerCase().includes(action.alvo.toLowerCase().trim())
      )

      return {
        ...state,
        produtos: [...returnPesquisaDescricao, ...returnPesquisaCodigo],
      }

    case 'SET_PRODUCTS':
      return {
        ...state,
        produtosTodos: action.produtos,
        produtos: action.produtos,
      }

    case 'FILTER_CATEGORY':
      if (action.categoria)
        action.categoria.selecionado = !action.categoria.selecionado
      const selecionados = state.categorias
        .filter((c) => c.selecionado)
        .map((s) => s.codCategoria)

      if (selecionados <= 0) {
        return { ...state, produtos: state.produtosTodos }
      }
      return {
        ...state,
        produtos: state.produtosTodos.filter((p) =>
          selecionados.includes(p.codCategoria)
        ),
      }

    case 'CLEAR_FILTERS':
      return {
        produtos: [...state.produtosTodos],
        categorias: allCategories.map((cat) => {
          return { ...cat, selecionado: false }
        }),
      }

    default:
      return state
  }
}
